import { render, staticRenderFns } from "./menu-slot-ship.vue?vue&type=template&id=4f5b2730&"
import script from "./menu-slot-ship.vue?vue&type=script&lang=js&"
export * from "./menu-slot-ship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports